export const LOGIN_START = "LOGIN_START";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_RESULT = "LOGIN_RESULT";
export const LOGIN_FAIL = "LOGIN_FAIL";
